import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

export default function Projects() {
  return (
    <Box>
      <Typography variant="h4" gutterBottom sx={{ fontWeight: 600 }}>
        Projects
      </Typography>
      <Paper sx={{ p: 4, mt: 3, textAlign: 'center' }}>
        <Typography variant="body1" color="text.secondary">
          Projects page - Coming soon...
        </Typography>
      </Paper>
    </Box>
  );
}
